import axios from "axios"
import Cookies from "universal-cookie"

export const getAccessToken = async () => {
  try {
    const uid = new Cookies().get("uid-r")
    const body = uid ? { action: "getJWT", UID: uid } : { action: "getJWT" }
    const response = await axios.post(
      process.env.URL_TOKENIZER,
      body,
      { headers: { apikey: process.env.URL_TOKENIZER_APIKEY, "Content-Type": "application/json" } },
    )
    return response
  } catch (error) {
    console.error('[getAccessToken]', error)
    return undefined
  }
}

